import { FilesActions } from './actions'
import { ADD_FILE, LOAD_FILES, REMOVE_FILE } from './actionTypes'
import { DataFileInterface } from '@systemeio/file-manager'

export type FilesState = { [key: string]: DataFileInterface }

const initialState: FilesState = {}

function removeFile(files: FilesState, removableFile: DataFileInterface) {
  return Object.values(files)
    .filter(file => file.id !== removableFile.id)
    .reduce((acc, file) => ({ ...acc, [file.id]: file }), {} as FilesState)
}

export function filesReducer(state = initialState, action: FilesActions) {
  switch (action.type) {
    case LOAD_FILES:
      return {
        ...state,
        ...action.payload.reduce(
          (acc, file) => ({
            ...acc,
            [file.id]: file,
          }),
          {},
        ),
      }
    case REMOVE_FILE:
      return removeFile(state, action.payload)
    case ADD_FILE:
      return {
        ...state,
        [action.payload.id]: action.payload,
      }
    default:
      return state
  }
}

function getFiles(state: FilesState): DataFileInterface[] {
  return Object.values(state)
}

export const selectors = {
  getFiles,
}
